import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
  //Comment By Vaishali For Staging
  enableProdMode();
}

/**
 * Google sign-in on the web runs in a popup that Google sends back to our
 * origin with the tokens in the URL hash. The social-login plugin hands them
 * to the opener window the moment its web implementation is constructed, then
 * closes the popup. Do that here, before Angular boots, so the router never
 * gets a chance to rewrite the URL and drop the hash. A normal page load has
 * no opener and takes the usual path.
 */
const oauthPayload = /(^|[#&?])(id_token|access_token|code|error)=/.test(
  window.location.hash + window.location.search
);
const finishingOAuthPopup =
  !!window.opener && oauthPayload && localStorage.getItem('social_login_oauth_pending') !== null;

function bootApp() {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.log(err));
}

if (finishingOAuthPopup) {
  // The plugin posts the tokens to the opener and closes this window. If
  // that has not happened in a few seconds, boot normally rather than leave
  // a blank page.
  const fallback = setTimeout(bootApp, 4000);
  import('@capgo/capacitor-social-login')
    .then(({SocialLogin}) => SocialLogin.initialize({}))
    .catch((err) => {
      console.error('OAuth popup hand-back failed', err);
      clearTimeout(fallback);
      localStorage.removeItem('social_login_oauth_pending');
      bootApp();
    });
} else {
  bootApp();
}
